/**
 * Parent Reference Data
 * 
 * Centralized parent reference data (word lists, spelling words, math facts, etc.)
 * extracted from App.jsx
 */

export const parentReference = {
  phonics: {
    title: 'Phonics Word Lists',
    icon: '📚',
    categories: [
      {
        name: 'TH Words',
        words: [
          { word: 'then', example: 'First we eat, then we play.' },
          { word: 'than', example: 'I am taller than my brother.' },
          { word: 'think', example: 'I think it will rain today.' },
          { word: 'that', example: 'That book is my favorite.' },
          { word: 'this', example: 'This cookie tastes delicious.' },
          { word: 'with', example: 'I play with my friends at recess.' },
          { word: 'bath', example: 'I take a bath before bedtime.' },
          { word: 'math', example: 'I love learning math at school.' },
          { word: 'path', example: 'We walked down the garden path.' },
          { word: 'both', example: 'Both of my hands are clean.' },
          { word: 'month', example: 'My birthday is next month.' },
          { word: 'north', example: 'The North Pole is very cold.' },
          { word: 'south', example: 'Birds fly south for the winter.' },
          { word: 'earth', example: 'We live on planet Earth.' },
          { word: 'birth', example: 'The birth of a baby is special.' }
        ]
      },
      {
        name: 'WH Words',
        words: [
          { word: 'when', example: 'When will we go to the park?' },
          { word: 'where', example: 'Where did you put your backpack?' },
          { word: 'what', example: 'What is your favorite color?' },
          { word: 'which', example: 'Which book would you like to read?' },
          { word: 'who', example: 'Who is your best friend?' },
          { word: 'why', example: 'Why is the sky blue?' },
          { word: 'whip', example: 'The cowboy cracked his whip.' },
          { word: 'whale', example: 'The whale swam in the ocean.' },
          { word: 'wheel', example: 'The wheel on the bus goes round and round.' },
          { word: 'white', example: 'The snow is white and fluffy.' },
          { word: 'whisper', example: 'Please whisper in the library.' },
          { word: 'whistle', example: 'The referee blew his whistle.' },
          { word: 'wheat', example: 'Bread is made from wheat.' },
          { word: 'whisk', example: 'I use a whisk to mix the eggs.' },
          { word: 'whiskers', example: 'The cat has long whiskers.' }
        ]
      },
      {
        name: 'SH Words',
        words: [
          { word: 'show', example: 'Can you show me how to do this?' },
          { word: 'ship', example: 'The ship sailed across the ocean.' },
          { word: 'shop', example: 'We went to the shop to buy groceries.' },
          { word: 'she', example: 'She is my best friend.' },
          { word: 'shoe', example: 'I put on my shoe before going outside.' },
          { word: 'fish', example: 'The fish swims in the pond.' },
          { word: 'wish', example: 'I wish upon a star at night.' },
          { word: 'wash', example: 'I wash my hands before eating.' },
          { word: 'brush', example: 'I brush my teeth every morning.' },
          { word: 'crash', example: 'The waves crash on the beach.' },
          { word: 'flash', example: 'The lightning made a bright flash.' },
          { word: 'splash', example: 'I like to splash in the puddles.' },
          { word: 'squash', example: 'I squash the bug with my shoe.' },
          { word: 'smash', example: 'The ball will smash the window.' },
          { word: 'trash', example: 'Please throw that in the trash.' }
        ]
      },
      {
        name: 'CH Words',
        words: [
          { word: 'chair', example: 'I sit in my chair at the table.' },
          { word: 'cheese', example: 'I love to eat cheese and crackers.' },
          { word: 'chicken', example: 'The chicken lays eggs in the coop.' },
          { word: 'child', example: 'Every child deserves to be happy.' },
          { word: 'chin', example: 'I rest my chin on my hands.' },
          { word: 'chip', example: 'I ate a potato chip for a snack.' },
          { word: 'chop', example: 'I chop vegetables for dinner.' },
          { word: 'church', example: 'We go to church on Sunday.' },
          { word: 'lunch', example: 'I eat my lunch at noon.' },
          { word: 'march', example: 'The band will march in the parade.' },
          { word: 'much', example: 'I don\'t have much time left.' },
          { word: 'such', example: 'She is such a good friend.' },
          { word: 'teach', example: 'My teacher will teach me to read.' },
          { word: 'reach', example: 'I can reach the top shelf now.' },
          { word: 'catch', example: 'I will catch the ball with my hands.' }
        ]
      },
      {
        name: 'PH Words',
        words: [
          { word: 'phone', example: 'I talk to grandma on the phone.' },
          { word: 'photo', example: 'I took a photo of my family.' },
          { word: 'elephant', example: 'The elephant has a long trunk.' },
          { word: 'alphabet', example: 'I learned the alphabet in school.' },
          { word: 'graph', example: 'The graph shows how tall I am.' },
          { word: 'paragraph', example: 'I wrote a paragraph for homework.' },
          { word: 'dolphin', example: 'The dolphin jumped out of the water.' },
          { word: 'trophy', example: 'I won a trophy for running fast.' },
          { word: 'sophomore', example: 'My sister is a sophomore in high school.' },
          { word: 'pharmacy', example: 'We get medicine at the pharmacy.' },
          { word: 'phrase', example: 'That is a nice phrase to remember.' },
          { word: 'phase', example: 'The moon goes through different phases.' },
          { word: 'physics', example: 'Physics is the study of how things move.' },
          { word: 'phantom', example: 'The phantom appeared in the story.' },
          { word: 'phoenix', example: 'The phoenix is a mythical bird.' }
        ]
      },
      {
        name: 'CK Words',
        words: [
          { word: 'duck', example: 'The duck quacks in the pond.' },
          { word: 'back', example: 'I will come back home soon.' },
          { word: 'pack', example: 'I pack my lunch for school.' },
          { word: 'sack', example: 'I carry my toys in a sack.' },
          { word: 'tack', example: 'I use a tack to hang the picture.' },
          { word: 'black', example: 'The cat is black and white.' },
          { word: 'clock', example: 'The clock shows what time it is.' },
          { word: 'dock', example: 'The boat is tied to the dock.' },
          { word: 'block', example: 'I build a tower with my block.' },
          { word: 'rock', example: 'I found a smooth rock at the beach.' },
          { word: 'sock', example: 'I put on my sock before my shoe.' },
          { word: 'lock', example: 'I lock the door at night.' },
          { word: 'shock', example: 'The news gave me a shock.' },
          { word: 'stock', example: 'The store has stock on the shelves.' },
          { word: 'truck', example: 'The truck delivers packages to our house.' },
          { word: 'stuck', example: 'My shoe got stuck in the mud.' }
        ]
      },
      {
        name: 'TCH Words',
        words: [
          { word: 'catch', example: 'I will catch the ball when you throw it.' },
          { word: 'match', example: 'The socks are a perfect match.' },
          { word: 'patch', example: 'I sewed a patch on my jeans.' },
          { word: 'watch', example: 'I watch cartoons on Saturday morning.' },
          { word: 'stretch', example: 'I stretch my arms up high.' },
          { word: 'fetch', example: 'The dog will fetch the ball for me.' },
          { word: 'itch', example: 'The mosquito bite makes me itch.' },
          { word: 'notch', example: 'I made a notch in the stick.' },
          { word: 'stitch', example: 'The doctor gave me a stitch in my cut.' },
          { word: 'ditch', example: 'The car got stuck in the ditch.' },
          { word: 'witch', example: 'The witch flew on her broomstick.' },
          { word: 'hitch', example: 'I will hitch the wagon to the horse.' },
          { word: 'switch', example: 'I flip the switch to turn on the light.' },
          { word: 'sketch', example: 'I draw a sketch of my house.' },
          { word: 'scratch', example: 'The cat will scratch the post.' }
        ]
      }
    ]
  },
  spelling: {
    title: 'Spelling Word Lists',
    icon: '✏️',
    categories: [
      {
        name: 'October Words (Test 10/31)',
        words: [
          { word: 'than', example: 'I am taller than my sister.', usage: 'Used to compare two things' },
          { word: 'think', example: 'I think it will rain today.', usage: 'To use your mind to consider something' },
          { word: 'their', example: 'The children played with their toys.', usage: 'Shows something belongs to them' },
          { word: 'these', example: 'These cookies are delicious!', usage: 'Points to things close by (plural)' },
          { word: 'when', example: 'When will we go to the park?', usage: 'Asks about time' },
          { word: 'each', example: 'Each student gets a pencil.', usage: 'Every single one' },
          { word: 'such', example: 'She is such a good friend.', usage: 'Used to emphasize or describe' },
          { word: 'me', example: 'Can you help me with this?', usage: 'Refers to yourself' },
          { word: 'find', example: 'I need to find my lost shoe.', usage: 'To discover or locate something' },
          { word: 'see', example: 'I can see the bird in the tree.', usage: 'To look at with your eyes' }
        ]
      },
      {
        name: 'November Words',
        words: [
          { word: 'come', example: 'Please come to dinner.', usage: 'To move toward someone or something' },
          { word: 'some', example: 'I would like some milk.', usage: 'An amount that is not all' },
          { word: 'done', example: 'I am done with my homework.', usage: 'Finished or completed' },
          { word: 'one', example: 'I have one apple left.', usage: 'The number 1' },
          { word: 'none', example: 'There are none left in the box.', usage: 'Not any, zero' },
          { word: 'gone', example: 'The bus has gone already.', usage: 'Left or moved away' },
          { word: 'fun', example: 'Playing games is so much fun!', usage: 'Enjoyable or entertaining' },
          { word: 'run', example: 'I like to run in the park.', usage: 'To move quickly on your feet' },
          { word: 'sun', example: 'The sun is shining brightly.', usage: 'The bright star in our sky' },
          { word: 'bun', example: 'I ate a hot dog in a bun.', usage: 'A type of bread roll' }
        ]
      },
      {
        name: 'December Words',
        words: [
          { word: 'red', example: 'The apple is red and shiny.', usage: 'The color of fire trucks and roses' },
          { word: 'bed', example: 'I sleep in my bed at night.', usage: 'Furniture for sleeping' },
          { word: 'fed', example: 'I fed the dog this morning.', usage: 'Gave food to (past tense of feed)' },
          { word: 'led', example: 'The teacher led us to the library.', usage: 'Showed the way (past tense of lead)' },
          { word: 'wed', example: 'They got wed last summer.', usage: 'Married (past tense of wed)' },
          { word: 'said', example: 'She said hello to me.', usage: 'Spoke words (past tense of say)' },
          { word: 'paid', example: 'I paid for my lunch today.', usage: 'Gave money for something (past tense of pay)' },
          { word: 'laid', example: 'The hen laid an egg.', usage: 'Put something down (past tense of lay)' },
          { word: 'maid', example: 'The maid cleaned the room.', usage: 'A woman who cleans houses' },
          { word: 'afraid', example: 'I am afraid of the dark.', usage: 'Feeling scared or frightened' }
        ]
      },
      {
        name: 'January Words',
        words: [
          { word: 'blue', example: 'The sky is blue today.', usage: 'The color of the ocean and sky' },
          { word: 'true', example: 'It is true that cats like fish.', usage: 'Real or correct, not false' },
          { word: 'glue', example: 'I used glue to fix my toy.', usage: 'A sticky substance for joining things' },
          { word: 'clue', example: 'The footprint was a clue.', usage: 'A hint that helps solve a mystery' },
          { word: 'due', example: 'My homework is due tomorrow.', usage: 'Expected or supposed to happen' },
          { word: 'new', example: 'I got a new bike for my birthday.', usage: 'Not old, recently made or bought' },
          { word: 'few', example: 'There are only a few cookies left.', usage: 'A small number, not many' },
          { word: 'grew', example: 'The plant grew tall and strong.', usage: 'Got bigger (past tense of grow)' },
          { word: 'flew', example: 'The bird flew over the house.', usage: 'Moved through the air (past tense of fly)' },
          { word: 'drew', example: 'She drew a picture of a cat.', usage: 'Made a picture with pencil (past tense of draw)' }
        ]
      },
      {
        name: 'February Words',
        words: [
          { word: 'green', example: 'The grass is green in spring.', usage: 'The color of grass and leaves' },
          { word: 'seen', example: 'I have seen that movie before.', usage: 'Looked at with eyes (past tense of see)' },
          { word: 'been', example: 'I have been to the zoo.', usage: 'Existed or happened (past tense of be)' },
          { word: 'queen', example: 'The queen lives in a castle.', usage: 'A female ruler of a country' },
          { word: 'screen', example: 'I watch movies on the screen.', usage: 'The flat surface on TVs and computers' },
          { word: 'between', example: 'The cat sat between the dogs.', usage: 'In the middle of two things' },
          { word: 'fifteen', example: 'I am fifteen years old.', usage: 'The number 15' },
          { word: 'sixteen', example: 'There are sixteen candles on the cake.', usage: 'The number 16' },
          { word: 'seventeen', example: 'I counted seventeen birds.', usage: 'The number 17' },
          { word: 'eighteen', example: 'She will be eighteen next year.', usage: 'The number 18' }
        ]
      },
      {
        name: 'March Words',
        words: [
          { word: 'yellow', example: 'The sunflowers are bright yellow.', usage: 'The color of the sun and bananas' },
          { word: 'fellow', example: 'He is a nice fellow.', usage: 'A man or boy, a person' },
          { word: 'mellow', example: 'The music was soft and mellow.', usage: 'Gentle, soft, or relaxed' },
          { word: 'bellow', example: 'The cow will bellow loudly.', usage: 'To make a deep, loud sound' },
          { word: 'swallow', example: 'I will swallow my medicine.', usage: 'To take food or liquid down your throat' },
          { word: 'follow', example: 'Please follow me to the classroom.', usage: 'To go after someone or come behind' },
          { word: 'hollow', example: 'The tree trunk is hollow inside.', usage: 'Empty on the inside' },
          { word: 'pillow', example: 'I rest my head on my pillow.', usage: 'A soft cushion for your head' },
          { word: 'willow', example: 'The willow tree has long branches.', usage: 'A type of tree with drooping branches' },
          { word: 'billow', example: 'The clouds billow in the sky.', usage: 'To swell or move in waves' }
        ]
      }
    ]
  },
  math: {
    title: 'Math Facts & Numbers',
    icon: '🔢',
    categories: [
      {
        name: 'Addition Facts (0-10)',
        words: ['0+0=0', '1+1=2', '2+2=4', '3+3=6', '4+4=8', '5+5=10', '6+6=12', '7+7=14', '8+8=16', '9+9=18', '10+10=20']
      },
      {
        name: 'Subtraction Facts (0-10)',
        words: ['10-0=10', '10-1=9', '10-2=8', '10-3=7', '10-4=6', '10-5=5', '10-6=4', '10-7=3', '10-8=2', '10-9=1', '10-10=0']
      },
      {
        name: 'Skip Counting by 2s',
        words: ['2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30']
      },
      {
        name: 'Skip Counting by 5s',
        words: ['5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75']
      },
      {
        name: 'Skip Counting by 10s',
        words: ['10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150']
      },
      {
        name: 'Number Words (1-20)',
        words: ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen', 'twenty']
      }
    ]
  },
  reading: {
    title: 'Reading Comprehension',
    icon: '📖',
    categories: [
      {
        name: 'Story Elements Questions',
        words: ['Who are the characters?', 'Where does the story take place?', 'When does the story happen?', 'What is the problem?', 'How is the problem solved?', 'What happens at the beginning?', 'What happens in the middle?', 'What happens at the end?']
      },
      {
        name: 'Sight Words (First 50)',
        words: ['a', 'and', 'are', 'as', 'at', 'be', 'been', 'but', 'by', 'for', 'from', 'had', 'has', 'have', 'he', 'his', 'how', 'I', 'if', 'in', 'is', 'it', 'its', 'just', 'like', 'long', 'look', 'made', 'make', 'many', 'may', 'more', 'my', 'no', 'not', 'now', 'number', 'of', 'on', 'one', 'or', 'other', 'out', 'part', 'people', 'said', 'see', 'she', 'so', 'some']
      },
      {
        name: 'Rhyming Words',
        words: ['cat/hat/bat', 'dog/log/fog', 'sun/fun/run', 'cake/bake/make', 'ball/call/fall', 'tree/bee/see', 'car/star/far', 'book/look/cook', 'play/day/say', 'night/light/bright']
      }
    ]
  },
  science: {
    title: 'Science Vocabulary',
    icon: '🔬',
    categories: [
      {
        name: 'Weather Words',
        words: ['sunny', 'cloudy', 'rainy', 'snowy', 'windy', 'stormy', 'foggy', 'hot', 'cold', 'warm', 'cool', 'temperature', 'thermometer', 'precipitation', 'evaporation']
      },
      {
        name: 'Plant Parts',
        words: ['root', 'stem', 'leaf', 'flower', 'seed', 'fruit', 'bark', 'branch', 'trunk', 'petal', 'pollen', 'photosynthesis', 'germination', 'growth', 'nutrients']
      },
      {
        name: 'Animal Groups',
        words: ['mammal', 'bird', 'fish', 'reptile', 'amphibian', 'insect', 'spider', 'butterfly', 'bee', 'ant', 'frog', 'snake', 'turtle', 'whale', 'eagle']
      },
      {
        name: 'Body Parts',
        words: ['head', 'eyes', 'ears', 'nose', 'mouth', 'teeth', 'tongue', 'neck', 'shoulders', 'arms', 'hands', 'fingers', 'chest', 'stomach', 'legs', 'feet', 'toes']
      }
    ]
  }
};

